import styled from 'styled-components';
import { breakpoints, css } from '../../styles/theme';
import SummaryPriceDetails from './SummaryPriceDetailsTemplate';
import { rem } from 'polished';

export const SummaryPriceDetailsStyled = styled(SummaryPriceDetails)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey12};

    ${({ isBasket }) =>
        !isBasket &&
        css`
            border-bottom: ${rem(1)} solid ${({ theme }) => theme.colors.grey12};
        `}

    ${({ isBasket, isDealer }) =>
        !isBasket &&
        !isDealer &&
        css`
            border-top: unset;
            border-bottom: unset;
            @media (min-width: ${breakpoints.sm}px) {
                border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey12};
                border-bottom: ${rem(1)} solid ${({ theme }) => theme.colors.grey12};
            }
        `}

    &.isClosed {
        .titleWrapper {
            padding: ${rem('20px')} 0 ${rem('20px')} 0;
        }
    }

    &.isOpen {
        padding-bottom: ${rem('20px')};
    }

    ${({ isBasket }) =>
        !isBasket &&
        `
        margin: ${rem(30)} ${rem(10)} 0 ${rem(10)};
    `}

    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem('20px')} 0 0 0;
        width: 100%;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                width: ${rem(25)};
                height: ${rem(25)};
                margin-right: ${({ isBasket }) => !isBasket && rem(10)};
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .descriptionTitle {
        width: 20%;
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        font-size: ${({ theme }) => theme.fontSizes.textBase};

        &.emptyTitle {
            padding: 0 !important;
        }

        @media (max-width: ${breakpoints.md}px) {
            padding-bottom: ${rem(15)};
        }
    }

    .descriptionSection {
        padding: 0;
        display: flex;
        justify-content: space-between;
        width: 80%;

        @media (max-width: ${breakpoints.md}px) {
            width: 100%;
            align-items: center;
        }
    }

    .descriptionWrapper {
        padding: ${rem(30)} 0;
        border-top: 1px solid ${({ theme }) => theme.colors.grey25};

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
        }

        .description {
            @media (max-width: ${breakpoints.md}px) {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
            }
        }

        .info {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            padding: ${rem(5)} 0;
            width: 50%;

            @media (min-width: ${breakpoints.md}px) {
                display: flex;
                width: 100%;
            }

            .key {
                width: ${rem(95)};
                padding-bottom: ${rem(5)};
                color: ${({ theme }) => theme.colors.primaryDisabled};
                margin-right: ${rem(20)};
            }

            .value {
                color: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .colorWrapper,
    .interiorWrapper,
    .optionWrapper,
    .priceWrapper {
        padding: ${rem(30)} 0;
        border-top: 1px solid ${({ theme }) => theme.colors.grey25};

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
            align-items: center;
        }

        .key {
            @media (min-width: ${breakpoints.md}px) {
                width: 40%;
            }
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }

        .value {
            width: 40%;
            text-align: right;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }
    }

    .optionWrapper {
        align-items: flex-start;

        .options {
            width: 100%;

            @media (min-width: ${breakpoints.md}px) {
                width: 80%;
            }
        }

        .descriptionSection {
            width: 100%;
            align-items: flex-end;
            padding-bottom: ${rem(10)};

            .key {
                width: 80%;
            }
        }

        .key {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
        }
    }

    .priceWrapper {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    .totalPriceWrapper {
        display: flex;
        padding: ${rem(16)} 0 0 0;
        border-top: 1px solid ${({ theme }) => theme.colors.grey25};
        justify-content: space-between;

        .titleValidDateWrapper {
            display: flex;
            flex-direction: column;

            &__validDate {
                display: block;
                font-size: ${({ theme }) => theme.fontSizes.textBase};
            }
        }

        .prefix,
        .suffix {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            padding-right: ${rem(4)};
        }

        .suffix {
            margin-right: ${rem(5)};
        }

        .totalPriceTitle {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            display: flex;
            flex-direction: column;

            .offerValidity {
                margin-bottom: ${rem(4)};
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                display: flex;
                justify-content: center;
                gap: ${rem(4)};
                align-items: center;

                .tooltip {
                    display: inline-flex;
                    margin-left: ${rem(4)};

                    button {
                        background: none;
                        padding: 0;
                        border: none;
                        cursor: pointer;
                    }
                }
            }
        }

        .totalPrice {
            padding-top: ${rem('20px')};
            display: flex;
            flex-direction: column;
            align-items: end;

            @media (min-width: ${breakpoints.md}px) {
                padding: 0;
                text-align: right;
            }

            .cashPrice,
            .monthlyPrice {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            .isShowPriceExcludedVAT {
                margin-top: 10px;
            }

            .monthlyPrice {
                display: flex;
                padding: 0 ${rem(4)} ${rem(4)} 0;
                flex-direction: column;
                align-items: flex-end;

                @media (min-width: ${breakpoints.md}px) {
                    justify-content: flex-end;
                }

                .financeDetailLinkMobile {
                    margin-top: 10px;
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                    font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                    cursor: pointer;
                    border-bottom: 1px solid ${({ theme }) => theme.colors.black};

                    strong {
                        font-weight: normal;
                    }

                    &:hover {
                        color: ${({ theme }) => theme.colors.primary};
                        border-color: ${({ theme }) => theme.colors.primary};
                    }
                }

                .monthlyPriceWrapper {
                    white-space: nowrap;
                }
            }

            .primaryText {
                font-size: ${rem(12)};
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                max-width: ${rem(400)};
                padding-top: ${rem(4)};
            }

            .priceInfo {
                font-size: ${({ theme }) => theme.fontSizes.textTiny};

                .promotionalTextWrapper {
                    display: flex;
                    flex-direction: column;
                }
            }
        }
    }

    .noValidityDate {
        justify-content: flex-end !important;
    }

    .finance {
        padding: ${rem(10)} 0 ${rem(30)} 0;
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        justify-content: space-between;

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
        }

        .validDate,
        .financePersonalize {
            display: flex;
            align-items: center;
        }

        .validDate {
            display: none;
            @media (max-width: ${breakpoints.xs}px) {
                display: block;
            }
        }

        .financePersonalize {
            .financeWidgetLinkWrapper {
                display: flex;
                align-items: center;
            }

            .financeWidgetLink,
            .financeDetailLinkDesktop {
                cursor: pointer;
                border-bottom: 1px solid ${({ theme }) => theme.colors.black};
                border-top: none;
                border-left: none;
                border-right: none;
                background: none;
                padding: 0;

                &:hover,
                &:focus-visible {
                    color: ${({ theme }) => theme.colors.primary};
                    border-color: ${({ theme }) => theme.colors.primary};
                }
            }

            .financeDetailLinkDesktop {
                margin-left: ${rem(15)};
                strong {
                    font-weight: normal;
                }

                @media (max-width: ${breakpoints.md}px) {
                    display: none;
                }
            }
        }
    }

    .configuration {
        margin-bottom: ${rem(20)};
        margin-top: -${rem(10)};

        button {
            padding: 0;
            border: none;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            color: ${({ theme }) => theme.colors.blue2};
            background: none;
            cursor: pointer;
            display: flex;
            align-items: center;

            svg {
                width: ${rem(24)};
                height: ${rem(24)};
                margin-right: ${rem(5)};
                margin-top: ${rem(4)};
            }
        }

        .description {
            padding: 0 0 ${rem(10)} 0;
        }
    }

    .infoIcon {
        display: inline-block;
        .vertical {
            margin: 0;
            height: ${rem(16)};
        }

        svg {
            g {
                circle,
                line {
                    stroke: ${({ theme }) => theme.colors.primary};
                }
            }
        }
    }
`;
